import React, { useState } from 'react';
import Popup from 'reactjs-popup';

const BuilderPopup = ({ openModal, setOpen, title }) => {
    const closeModal = () => setOpen(false);
    return (
        <div>
            <Popup open={openModal} closeOnDocumentClick onClose={closeModal} lockScroll className="builder-popup">
                <div className="modal">
                    <div className="modal-header">
                        <h3>Add {title}</h3>
                    </div>
                    <div className="modal-content">
                        <form>
                            <div class="ces-header-action">
                                <div class="cha-header">
                                    <h4>Widget icon</h4>
                                </div>
                                <ul>
                                    <li>
                                        <a className="ac-icon-wrapper"><i class="ri-image-line"></i></a>
                                        <span>Svg icon</span>
                                    </li>
                                    <li>
                                        <a className="ac-icon-wrapper"><i class="ri-landscape-line"></i></a>
                                        <span>Png icon</span>
                                    </li>
                                    <li>
                                        <label for="upload-icon" className="ac-icon-wrapper">
                                            <i class="ri-upload-line"></i>
                                            <input id="upload-icon" type="file" name="custom-icon" />
                                        </label>
                                        <span>Custom</span>
                                        
                                    </li>
                                    <li>
                                        <a className="ac-icon-wrapper">
                                            <s><i class="ri-image-line"></i></s>
                                        </a>
                                        <span>None</span>
                                    </li>
                                </ul>
                            </div>
                            <div className="form-group">
                                <label>Widget title</label>
                                <input name="title" placeholder="Email"/>
                            </div>
                            <div className="form-group">
                                <input name="email" placeholder="e.g. jhondoe007@mail.com"/>
                            </div>
                            <div className="form-group">
                                <button type="submit" className="btn btn-submit">Save widget</button>
                            </div>
                            <div className="form-group">
                                <label for="keep-more-dgt"> <input id="keep-more-dgt" type="checkbox" /> Keep add more widgets</label>
                            </div>
                        </form>
                    </div>
                </div>
            </Popup>
        </div>
    );
};
export default BuilderPopup;